module.exports = __webpack_public_path__ + "static/12-4-32aba96fc1da90bbd2da573bdc1fae33.jpg";